module.exports = __webpack_public_path__ + "img/loginBgYun.2dd9847a.png";